import React from 'react';
import PropTypes from 'prop-types';
import { PayerSelect } from '@sde/widgets-core/src/widgets/PayerSelect';

export const PayerSelectWidget = ({ payerSelectProps, payer, setPayer }) => {
  return (
    <PayerSelect payer={payer} setPayer={setPayer} {...payerSelectProps} />
  );
};

PayerSelectWidget.propTypes = {
  payer: PropTypes.shape({
    payerId: PropTypes.string,
  }).isRequired,
  setPayer: PropTypes.func.isRequired,
  payerSelectProps: PropTypes.shape({}).isRequired,
};
